import { FC } from 'react';
import { Box, Divider, Grid, Typography } from '@material-ui/core';

import ErrorIcon from '@material-ui/icons/Error';
import WarningIcon from '@material-ui/icons/Warning';
import DoneIcon from '@material-ui/icons/Done';

import { createTitleAndDescription } from './utils.ts';
import { Category, RenderPreviewProps } from './types.ts';

export const PreviewNotificationComponent: FC<{
  data: RenderPreviewProps;
}> = ({ data }) => {
  const {
    category,
    name,
    status,
    title,
    authorName,
    description,
    instance,
    startDate,
    endDate,
    dateFns,
  } = data;

  const previewSubtitle = `plugin:zeiss-notifications • ${category} • 2 hours ago`;

  const createPreviewIcon = () => {
    switch (category) {
      case Category.Incident:
      case Category.SecurityIncident:
        return <ErrorIcon data-testid="ErrorIcon" />;

      case Category.Maintenance:
        return <WarningIcon data-testid="WarningIcon" />;

      case Category.Update:
        return <DoneIcon data-testid="DoneIcon" />;

      default:
        return <DoneIcon data-testid="DoneIcon" />;
    }
  };

  const previewIcon = createPreviewIcon();

  const { notificationTitle, notificationDescription } =
    createTitleAndDescription({
      category,
      name,
      status,
      title,
      authorName,
      description,
      instance,
      startDate,
      endDate,
      dateFns,
    });

  return (
    <Grid item xs={12}>
      <Box display="flex" flexDirection="column" gridGap={12}>
        <Divider style={{ marginTop: 0, marginBottom: 12 }} />

        <Typography variant="h6">Notification Preview</Typography>

        <Box
          display="flex"
          gridGap={4}
          padding={2}
          borderRadius={6}
          bgcolor="white"
          alignItems="center"
        >
          <Box marginRight={1}>{previewIcon}</Box>
          <Box display="flex" flexDirection="column">
            <Typography variant="subtitle1" color="primary">
              {notificationTitle}
            </Typography>

            <Typography variant="body2">{notificationDescription}</Typography>

            <Typography variant="caption">{previewSubtitle}</Typography>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};
